import React, {useState} from "react";
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom";
import './App.css';
import SubscriptionCalculator from './SubscriptionCalculator';
import SubscriptionWithPayment from './SubscriptionWithPayment';
import SubscriptionAdminPanel from './SubscriptionAdminPanel';
import PaymentSuccess from './PaymentSuccess';
import PaymentError from './PaymentError';
import {CookiesProvider, useCookies} from 'react-cookie';
import LoginWithHeader from "./LoginWithHeader";
import {showUserPanelUrl} from './data.js';
import {ToastContainer} from "react-toastify";
import Footer from "./ui/Footer";
import LegalPoliciesPage from "./ui/LegalPoliciesPage";
import {kvkkFormLabel, kvkkFormUrl, kvkkSections, kvkkTitle, kvkkUpdated} from "./legal/kvkkSections";
import {salesPolicyDocumentTitle, salesPolicySections, salesPolicyTitle} from "./legal/salesPolicySections";
import {setupLogging} from "./debug";

function App() {
    const [cookies, setCookie, removeCookie] = useCookies(['subscriptionToken']);
    const [admin, setAdmin] = useState(false);
    setupLogging();
    const isAdmin = () => {
        fetch(showUserPanelUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
            },
        }).then(res => {
            if (res.ok) {
                setAdmin(true)
            } else {
                setAdmin(false)
            }
        })
    };

    const AuthRoute = () => {
        isAdmin();
        if (!cookies.subscriptionToken) {
            return <Redirect
                to={{
                    pathname: "/subscription/login",
                }}
            />
        }

        if (admin) {
            return (<SubscriptionAdminPanel setCookie={setCookie} removeCookie={removeCookie}/>);
        }

        return (<SubscriptionWithPayment setCookie={setCookie} removeCookie={removeCookie}/>);
    }

    return (
        <CookiesProvider>
            <ToastContainer position="top-center"/>

            <Router>
                <div>
                    {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
                    <Switch>
                        <Route path="/subscription/login">
                            <LoginWithHeader setCookie={setCookie}/>
                        </Route>
                        <Route path="/subscription/tenant">
                            <div className="page-shell">
                                <AuthRoute/>
                                <Footer/>
                            </div>
                        </Route>
                        <Route path="/subscription/payment/success">
                            <PaymentSuccess/>
                        </Route>
                        <Route path="/subscription/payment/error">
                            <PaymentError/>
                        </Route>
                        <Route path="/subscription/admin">
                            <AuthRoute/>
                        </Route>
                        <Route path="/subscription/kisisel-verilerin-korunmasi">
                            <div className="page-shell legal-shell">
                                <LegalPoliciesPage title={kvkkTitle} updated={kvkkUpdated} sections={kvkkSections} formHref={kvkkFormUrl} formLabel={kvkkFormLabel}/>
                                <Footer/>
                            </div>
                        </Route>
                        <Route path="/subscription/on-bilgilendirme-ve-diger-politikalar">
                            <div className="page-shell legal-shell">
                                <LegalPoliciesPage title={salesPolicyTitle} documentTitle={salesPolicyDocumentTitle} sections={salesPolicySections} compactTitle/>
                                <Footer/>
                            </div>
                        </Route>
                        <Route path="/subscription">
                            <div className="page-shell">
                                <SubscriptionCalculator/>
                                <Footer/>
                            </div>
                        </Route>

                    </Switch>
                </div>
            </Router>
        </CookiesProvider>
    );
}

export default App;
